import { API_BASE_URL } from "./apiConfig";
import { logApiContext } from "../config/apiBaseUrl";

const API_URL = `${API_BASE_URL}/api/liquidaciones`;
const logRequest = (action, url) =>
  logApiContext(`liquidacionService:${action}`, { url, API_URL });

const authHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

export const getMyLiquidaciones = async ({ startDate, endDate, driverId, conductor } = {}) => {
  const urlObj = new URL(API_URL);
  if (startDate) urlObj.searchParams.set("startDate", startDate);
  if (endDate) urlObj.searchParams.set("endDate", endDate);
  if (driverId) urlObj.searchParams.set("driverId", driverId);
  if (conductor) urlObj.searchParams.set("conductor", conductor);

  const url = urlObj.toString();
  logRequest("getMyLiquidaciones", url);
  const res = await fetch(url, { headers: authHeaders() });
  if (!res.ok) throw new Error((await res.text()) || "Error al obtener liquidaciones");
  return res.json();
};

export const getLiquidacionById = async (id) => {
  const url = `${API_URL}/${id}`;
  logRequest("getLiquidacionById", url);
  const res = await fetch(url, { headers: authHeaders() });
  if (!res.ok) throw new Error((await res.text()) || "Error al obtener la liquidación");
  return res.json();
};
